var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-container"},[_c('apex-charts',{attrs:{"width":"400","type":"donut","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }